<template>
  <div class="custom-margin-full-page">
    <v-row>
      <v-col cols="12" class="text-left">

        <v-icon class="back-link-icon" x-large
                @click="$router.push('/dashboard/my-courses/lessons/'+courseId+'/'+classId)">mdi-arrow-left
        </v-icon>
      </v-col>
      <v-col cols="12">
        <v-card elevation="0" color="#1ab69d">
          <v-card-title>{{ item.item.title }}</v-card-title>
          <v-card-subtitle>{{ item.item.description }}</v-card-subtitle>
          <v-card-text v-if="isDictationCourse && lessonDictationCount > 0" class="lesson-dictation-summary">
            <div class="lesson-dictation-summary-head">
              <span>میانگین نمره</span>
              <strong :class="lessonUnlockStatusClass">
                {{ lessonAverageScoreDisplay }}%
              </strong>
            </div>
            <v-progress-linear
                :value="lessonAverageScore"
                :color="lessonUnlockColor"
                background-color="rgba(255,255,255,.22)"
                height="10"
                rounded
            />
            <div class="lesson-dictation-summary-meta">
              <span v-if="lessonNextLessonUnlocked" class="score-pass">
                <v-icon small color="#a7f3d0">mdi-lock-open-variant</v-icon>
                درس بعدی
              </span>
              <span v-else class="score-warn">
                <v-icon small color="#fde68a">mdi-lock</v-icon>
                هنوز قفل است
              </span>
            </div>
          </v-card-text>
          <v-card-text>
            <v-row>
              <v-col cols="12" v-for="lessonFile in item.files" :key="lessonFile.id">
                <v-row v-if="lessonFile.visibility">
                  <v-col cols="12" class="single-file-container">
                    <v-row>
                      <v-col cols="6" @click="openLessonFile(lessonFile)">
                        <div class="file-show-container" v-if="selectedLessonFileForShow.id === lessonFile.id">
                          <img v-if="selectedLessonFileForShow.mime_type === 'image'"
                               :src="selectedLessonFileForShow.file" class="image-lesson"
                               :alt="selectedLessonFileForShow.title">
                          <audio v-else-if="selectedLessonFileForShow.mime_type === 'audio'"
                                 :src="selectedLessonFileForShow.file"
                                 controls
                                 style="width: 100%"
                                 @loadedmetadata="restoreAudioProgress($event, lessonFile)"
                                 @ended="resetAudioApiCall(lessonFile)"
                                 @seeking="preventAudioForwardSeek($event, lessonFile)"
                                 @timeupdate="trackAudioProgress($event, lessonFile)"></audio>
                          <video-player-mobile class="mb-10" :options="videoOptions" source="onlineClassItem"
                                               :item-id="lessonFile.id"
                                               v-else-if="selectedLessonFileForShow.mime_type === 'video'">
                          </video-player-mobile>
                          <v-btn v-else style="letter-spacing: normal" width="100%"
                                 color="primary"
                                 @click="goTo(selectedLessonFileForShow.file)">مشاهده
                          </v-btn>
                        </div>
                        <img v-else :src="lessonFile.cover_file" :alt="lessonFile.title" width="100%"/>
                      </v-col>
                      <v-col cols="6">
                        <span style="color:white!important;">{{ lessonFile.title }} |</span>
                        <v-icon color="white" v-if="lessonFile.mime_type === 'video'">mdi-video</v-icon>
                        <v-icon color="white" v-if="lessonFile.mime_type === 'image'">mdi-image</v-icon>
                        <v-icon color="white" v-if="lessonFile.mime_type === 'audio'">mdi-music</v-icon>
                        <v-icon color="white" v-if="lessonFile.mime_type === 'text'">mdi-text</v-icon>
                        <v-icon color="white" v-if="lessonFile.mime_type === 'pdf'">mdi-file-pdf-box</v-icon>
                        <v-icon color="white" v-if="lessonFile.mime_type === 'other'">mdi-file-alert-outline</v-icon><br>
                        {{lessonFile.description}}
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
              <v-col :style="!dictation.visibility ? 'display:none!important' : ''"
                     :cols="dictation.visibility ? 12 : 0" v-for="dictation in item.dictations" :key="dictation.id+'dictation'">
                <v-row v-if="dictation.visibility">
                  <v-col cols="12" class="single-file-container">
                    <v-row>
                      <v-col cols="6" @click="openDictationFile(dictation)">
                        <img :src="dictation.cover_file" :alt="dictation.title" width="100%"/>
                      </v-col>
                      <v-col cols="6" style="color:white!important;">
<!--
                        {{ dictation.label != null ? dictation.label : dictation.title }} |
-->
<!--
                        <v-icon color="white">mdi-pen</v-icon>
-->
                        <br>
<!--                        {{ dictation.description }}-->
                      </v-col>
                      <v-col cols="12" v-if="hasDictationProgress(dictation)" class="dictation-score-wrap">
                        <div class="dictation-score-head">
                          <span>بهترین نمره</span>
                          <strong :class="dictationScoreClass(dictation)">
                            {{ dictationScore(dictation) }}%
                          </strong>
                        </div>
                        <v-progress-linear
                            :value="dictationScore(dictation)"
                            :color="dictationProgressColor(dictation)"
                            background-color="rgba(255,255,255,.22)"
                            height="10"
                            rounded
                        />
                        <div class="dictation-score-meta" v-if="isDictationCourse">
                          <span>حداقل امتیاز لازم {{ passThreshold }}%</span>
                          <span :class="dictation.is_passed ? 'score-pass' : 'score-warn'">
<!--                            {{ dictation.is_passed ? 'قبول شد' : 'هنوز نرسیده' }}-->
                          </span>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <lesson-chat-mobile :lesson-id="$route.params.itemId" :class-id="$route.params.classId"
                ></lesson-chat-mobile>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12">
        <lesson-assignment-mobile
            :lesson-id="$route.params.itemId"
            :class-id="$route.params.classId"
            :lesson-files="visibleLessonFiles">
        </lesson-assignment-mobile>
      </v-col>
      <v-col cols="12" class="mb-16"></v-col>
    </v-row>
  </div>
</template>

<script>
import VideoPlayerMobile from "@/components/Components/Mobile/Player/VideoPlayerMobile";
import LessonChatMobile from "@/components/Components/Mobile/Chat/LessonChatMobile";
import LessonAssignmentMobile from "@/components/Components/Mobile/Assignment/LessonAssignmentMobile";

export default {
  name: "LessonItemMobile",
  props: ['item', 'classId', 'courseId'],
  components: {VideoPlayerMobile, LessonChatMobile, LessonAssignmentMobile},
  data() {
    return {
      loading: true,
      selectedLessonFileForShow: {
        id: null
      },
      videoOptions: {
        autoplay: true,
        playbackRates: [1],
        controls: true,
        liveui: true,
        responsive: true,
        sources: [
          {
            src: '',
            type: "application/vnd.apple.mpegurl"
          }
        ],
      },
      audioLastApiCalls: {},
      audioMaxAllowedTimes: {},
      audioIsRestoringTime: {},
    }
  },
  computed: {
    visibleLessonFiles() {
      return Array.isArray(this.item && this.item.files)
          ? this.item.files.filter((lessonFile) => lessonFile.visibility)
          : []
    },
    isDictationCourse() {
      return Boolean(this.item && this.item.course && this.item.course.is_dictation_course)
    },
    passThreshold() {
      return Number((this.item && this.item.course && this.item.course.dictation_unlock_percentage) || 0)
    },
    lessonDictations() {
      return Array.isArray(this.item && this.item.dictations) ? this.item.dictations : []
    },
    lessonDictationCount() {
      return this.lessonDictations.length
    },
    lessonAverageScore() {
      const scores = this.lessonDictations
          .map((dictation) => Number(dictation && dictation.best_score))
          .filter((score) => Number.isFinite(score))

      if (!scores.length) {
        return 0
      }

      const average = scores.reduce((sum, score) => sum + score, 0) / scores.length
      return Math.max(0, Math.min(100, average))
    },
    lessonAverageScoreDisplay() {
      return this.lessonAverageScore.toFixed(2).replace(/\.00$/, '')
    },
    lessonNextLessonUnlocked() {
      if (!this.isDictationCourse || this.lessonDictationCount === 0) {
        return false
      }

      return this.lessonDictations.every((dictation) => Number(dictation && dictation.best_score) >= this.passThreshold)
    },
    lessonUnlockStatusClass() {
      return this.lessonNextLessonUnlocked ? 'score-pass' : 'score-warn'
    },
    lessonUnlockColor() {
      return this.lessonNextLessonUnlocked ? '#a7f3d0' : '#fde68a'
    },
  },
  methods: {
    normalizedScore(score) {
      const value = Number(score ?? 0)
      return Math.max(0, Math.min(100, Math.round(value)))
    },
    hasDictationProgress(dictation) {
      return Boolean(dictation && dictation.best_score !== null && dictation.best_score !== undefined)
    },
    dictationScore(dictation) {
      return this.normalizedScore(dictation && dictation.best_score)
    },
    dictationScoreClass(dictation) {
      if (!this.isDictationCourse) {
        return 'score-neutral'
      }

      return this.dictationScore(dictation) >= this.passThreshold ? 'score-pass' : 'score-warn'
    },
    dictationProgressColor(dictation) {
      if (!this.isDictationCourse) {
        return '#919295'
      }

      return this.dictationScore(dictation) >= this.passThreshold ? '#919295' : '#f59e0b'
    },
    openDictationFile(dictation) {
      console.log(dictation)
      const url = `/dashboard/my-courses/dictation/show/${this.$route.params.classId}/${this.$route.params.itemId}/${dictation.id}/${this.$store.state.user.id}`;
      window.open(url, '_blank');
    },
    goTo(path) {
      window.open(path)
    },
    openLessonFile(lessonFile) {
      if (lessonFile.mime_type === 'video') {
        this.videoOptions.sources[0].src = lessonFile.file
      }
      this.selectedLessonFileForShow = lessonFile
    },
    async restoreAudioProgress(event, lessonFile) {
      try {
        const response = await window.axios.get(`/student/tracker/get/${lessonFile.id}`)
        const seconds = Number(response.data.data?.seconds || 0)
        if (seconds > 0 && event.target.duration && seconds < event.target.duration) {
          this.$set(this.audioMaxAllowedTimes, lessonFile.id, Math.max(Number(this.audioMaxAllowedTimes[lessonFile.id] || 0), Math.floor(seconds)))
          this.$set(this.audioIsRestoringTime, lessonFile.id, true)
          event.target.currentTime = seconds
          this.$nextTick(() => {
            this.$set(this.audioIsRestoringTime, lessonFile.id, false)
          })
        }
      } catch (error) {
        console.error('Error fetching audio track:', error)
      }
    },
    preventAudioForwardSeek(event, lessonFile) {
      if (this.audioIsRestoringTime[lessonFile.id]) {
        return
      }

      const audio = event.target
      const maxAllowedTime = Number(this.audioMaxAllowedTimes[lessonFile.id] || 0)

      if (audio.currentTime > maxAllowedTime + 1) {
        this.$set(this.audioIsRestoringTime, lessonFile.id, true)
        audio.currentTime = maxAllowedTime
        this.openSnackbar('امکان جلو زدن فایل صوتی وجود ندارد.', '#F1416C')
        this.$nextTick(() => {
          this.$set(this.audioIsRestoringTime, lessonFile.id, false)
        })
      }
    },
    resetAudioApiCall(lessonFile) {
      this.$set(this.audioLastApiCalls, lessonFile.id, 0)
    },
    async trackAudioProgress(event, lessonFile) {
      if (this.audioIsRestoringTime[lessonFile.id]) {
        return
      }

      const currentTime = Math.floor(event.target.currentTime || 0)
      const lastApiCallTime = this.audioLastApiCalls[lessonFile.id] || 0
      const maxAllowedTime = Number(this.audioMaxAllowedTimes[lessonFile.id] || 0)

      if (currentTime < lastApiCallTime - 2) {
        this.$set(this.audioLastApiCalls, lessonFile.id, 0)
      }

      if (currentTime > maxAllowedTime + 2) {
        this.preventAudioForwardSeek(event, lessonFile)
        return
      }

      this.$set(this.audioMaxAllowedTimes, lessonFile.id, Math.max(Number(this.audioMaxAllowedTimes[lessonFile.id] || 0), currentTime))

      if (currentTime - lastApiCallTime < 10) {
        return
      }

      this.$set(this.audioLastApiCalls, lessonFile.id, currentTime)

      try {
        await window.axios.post('/student/tracker/create', {
          item_file_id: lessonFile.id,
          seconds: currentTime,
          type: 'audio'
        })
      } catch (error) {
        console.error('Error creating audio track:', error)
      }
    },
  },
  mounted() {
  }
}
</script>

<style scoped>
.image-lesson{
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 15px;
}
.custom-margin-full-page {
  margin: 5vh 2vw 0 2vw;
}

.lesson-dictation-summary {
  padding-top: 0;
}

.lesson-dictation-summary-head,
.lesson-dictation-summary-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  font-size: 13px;
  line-height: 1.6;
}

.lesson-dictation-summary-head {
  margin-bottom: 8px;
  color: rgba(255, 255, 255, 0.88);
}

.lesson-dictation-summary-meta {
  margin-top: 8px;
  color: rgba(255, 255, 255, 0.72);
}

.back-link-icon {
  color: #413e3e !important;
}

.back-link-icon:hover {
  color: orangered !important;
}

.dictation-score-wrap {
  margin-top: 10px;
}

.dictation-score-head,
.dictation-score-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  font-size: 12px;
  line-height: 1.6;
}

.dictation-score-head {
  margin-bottom: 8px;
  color: rgba(255, 255, 255, 0.88);
}

.dictation-score-meta {
  margin-top: 8px;
  color: rgba(255, 255, 255, 0.72);
}

.score-pass {
  color: #a7f3d0;
}

.score-warn {
  color: #fde68a;
}

.score-neutral {
  color: rgba(255, 255, 255, 0.88);
}
</style>
